import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Form, Input, Button } from 'antd';
import Cookie from 'js-cookie';

import { getHashValue } from 'shared/utils/url';
import Loader from 'shared/components/Loader/Loader';

import { logInUser, isError, isLoading, logInOID } from '../redux/auth.redux';
import Password from '../../shared/components/Password/Password';
import { AuthService } from '../oidc/AuthService';

import './LoginPage.css';


const FormItem = Form.Item;
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

@connect(
  state => ({
    isError: isError(state),
    isLoading: isLoading(state),
  }),
  { logInUser, logInOID },
)
class LoginPage extends Component {
  static propTypes = {
    isError: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    form: PropTypes.shape().isRequired,
    logInUser: PropTypes.func.isRequired,
    logInOID: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isError: false,
  };

  constructor(props) {
    super(props);
    const redurectURI = Cookie.get('OID_REDIRECT_URI');
    this.authService = new AuthService(redurectURI);
    this.state = {
      credentials: {
        username: '',
        password: '',
      },
      openIDUser: null,

      clientId: null,
      hostedDomain: '',
    };
  }

  componentWillMount() {
    this.checkOIDAuth();
  }

  componentDidMount() {
    this.props.form.validateFields();

    const clientId = Cookie.get('GOOGLE_CLIENT_ID');
    const hostedDomain = Cookie.get('GOOGLE_HOSTED_DOMAIN');

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      clientId,
      hostedDomain,
    });
  }

  checkOIDAuth = () => {
    this.authService.getUser().then((user) => {
      if (!user) {
        this.authService.loginCallback()
          .then(() => {
            const code = getHashValue('code');
            if (code) {
              this.props.logInOID({ code });
            }
          })
          .catch(() => false);
      } else {
        const code = getHashValue('code');
        if (code) {
          this.props.logInOID({ code });
        }
      }
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.form.validateFields(
      (err, values) => !err && this.props.logInUser(values),
    );
  };

  login = () => this.authService.login();

  render() {
    const {
      getFieldDecorator,
      isFieldTouched,
      getFieldsError,
      getFieldError,
    } = this.props.form;

    if (this.props.isLoading) {
      return (
        <Loader />
      );
    }

    const passwordError =
      isFieldTouched('password') && getFieldError('password');
    const emailError =
      isFieldTouched('Почта') && getFieldError('Почта');

    return (
      <Form className="login_form" onSubmit={this.handleSubmit}>
        <div className="header">
          Войти в систему
        </div>
        {
          this.props.isError &&
          <div className="login-form-error">
            <span>Неправильное имя пользователя или пароль</span>
          </div>
        }
        <FormItem
          label="Электронная почта"
          help={emailError || ''}
          validateStatus={emailError ? 'error' : ''}
        >
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Пожалуйста, заполните поле!' }, {
            }],
          })(
            <Input type="text" placeholder="example@domain.com" />,
          )}
        </FormItem>
        <FormItem
          help={passwordError || ''}
          validateStatus={passwordError ? 'error' : ''}
          label="Пароль"
          required
        >
          <Password
            fieldName="password"
            form={this.props.form}
            placeholder="Введите пароль"
            validateMessage="Пожалуйста, введите свой пароль!"
          />
        </FormItem>
        <FormItem>
          <div className="login_form_col">
            <Button
              type="primary"
              htmlType="submit"
              disabled={hasErrors(getFieldsError())}
              className="login-form-button"
            >
              ВХОД
            </Button>
          </div>
        </FormItem>
        <div className="g_btn_label">
          Или войдите с помощью
        </div>
        <div className="authBtns">
          <Button className="oidAuthBtn" onClick={this.login}>Open ID</Button>
        </div>


      </Form>
    );
  }
}

export default Form.create()(LoginPage);



// WEBPACK FOOTER //
// ./src/Auth/pages/LoginPage.js